import styled from "styled-components";

export const PaymentMethodCard = styled.div<{ margin?: string }>`
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 12px 16px;
  margin: ${({ margin }) => margin || "24px 0"};
  width: 100%;
  text-align: left;
  background: white;
  box-sizing: border-box;
`;

export const PaymentMethodLabel = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.greyMedium};
  font-weight: 500;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const PaymentMethodInfo = styled.div`
  font-size: 16px;
  color: #212529;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const CardInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CardIconImage = styled.img`
  width: 32px;
  height: 20px;
  object-fit: contain;
`;
